__turbopack_context__.v({
  "closeButton": "gV8Hta_closeButton",
  "content": "gV8Hta_content",
  "danger": "gV8Hta_danger",
  "description": "gV8Hta_description",
  "fadeIn": "gV8Hta_fadeIn",
  "fadeOut": "gV8Hta_fadeOut",
  "footer": "gV8Hta_footer",
  "header": "gV8Hta_header",
  "headerWithIcon": "gV8Hta_headerWithIcon",
  "icon": "gV8Hta_icon",
  "iconContainer": "gV8Hta_iconContainer",
  "info": "gV8Hta_info",
  "overlay": "gV8Hta_overlay",
  "success": "gV8Hta_success",
  "title": "gV8Hta_title",
  "warning": "gV8Hta_warning",
  "zoomIn": "gV8Hta_zoomIn",
  "zoomOut": "gV8Hta_zoomOut",
});
